function Resizer () {
  var self = this;

  this.init = function () {
    Bonkers.currentWidthName = '-';
    $(window).on('resize', function () {
      self.resize();
    });
    self.resize();
    Bonkers.width = {
      atLeast: function (width, plus) {
        plus = plus || 0;
        return window.innerWidth >= Bonkers.widths[width] + plus;
      },
      lessThan: function (width, minus) {
        minus = minus || 0;
        return window.innerWidth < Bonkers.widths[width] + minus;
      }
    };
  };

  this.resize = function () {
    var widthName = 'phone';
    var width = window.innerWidth;
    for (var key in Bonkers.widths) {
      if (width >= Bonkers.widths[key]) {
        widthName = key;
      }
    }
    if (Bonkers.currentWidthName !== widthName) {
      Bonkers.currentWidthName = widthName;
      window.dispatchEvent(new CustomEvent('windowResize'));
    }
  };
}

$(function () {
  var resizer = new Resizer();
  resizer.init();
});
